import { isBefore } from "date-fns";
import { nowTimestamp, Timestamp, timestampToDate } from "../core";
import { Invitation, InvitationStatus } from "./types.generated";

export function invitationStatus<R>(
  invitation: Invitation<R>,
  timestamp?: Timestamp | null
): InvitationStatus {
  timestamp = timestamp ?? nowTimestamp();
  if (invitation.accepted != null) {
    return "Accepted";
  } else if (invitation.canceled != null) {
    return "Canceled";
  } else if (
    invitation.expires != null &&
    isBefore(timestampToDate(invitation.expires), timestampToDate(timestamp))
  ) {
    return "Expired";
  } else {
    return "Pending";
  }
}
